import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import {
    Button,
    Row,
    Col,
    Form,
    FormGroup,
    Container,
} from 'reactstrap';

import CustomInput from '../../components/CustomInput';

import {
    check_empty_field
} from './validationChecks';

import {
    showLoading,
    showFeatureComingSoon,
    fetchPropertyTenants,
    shiftTenant,
    fetchOptions
} from '../../redux/actions';
import { Typeahead } from 'react-bootstrap-typeahead';
import CustomLabel from '../../components/CustomLabel';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import CustomPropertySelect from '../../components/CustomPropertySelect';
import { renderTenantSearchMenu } from '../../utils';
import { IonButton } from '@ionic/react';


const mapStateToProps = state => {
    return {
        properties: state.properties,
        tenants: state.tenants,
        units: state.units,
        options: state.options
    };
}

const mapDispatchToProps = {
    showLoading,
    fetchPropertyTenants,
    showFeatureComingSoon,
    shiftTenant,
    fetchOptions
};


class ShiftTenantForm extends React.Component {
    constructor(props) {
        super(props);
        let unit = [];
        let tenant = [];
        let tenantOptions = [];
        let unitOptions = [];



        this.state = {
            tenant,
            propertyId : "",
            properties: [],
            unit: unit,
            tenantOptions,
            unitOptions,
            errors: {
                unit: "",
                tenant: "",
            },
            numErrors: 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async setUnitOptions(propertyId = "") {
        let unitOptions = [];
        let unitOccupied = [];
        if (propertyId) {
            for (let unit of Object.values(this.props.units)) {
                if (unit.propertyId == propertyId) {
                    if (unit.occupied){
                        unitOccupied.push(this.getUnitOption(unit))
                    } else {
                        unitOptions.push(this.getUnitOption(unit));
                    }
                }
            }
            unitOptions = unitOptions.concat(unitOccupied);
            this.setState({
                unitOptions
            });
        }

    }

    async setTenantOptions(propertyId = "") {
        let tenantOptions = [];

        if (propertyId) {
            this.props.showLoading(true)
            const action = await this.props.fetchPropertyTenants({ propertyIds: [propertyId] });
            for (let tenant of Object.values(action.payload.tenants)) {
                if (!tenant.archived) {
                    tenantOptions.push(this.getTenantOption(tenant));
                }
            }
        }
        let selectedTenant = this.state.tenant.length > 0 ? this.state.tenant[0]: null;
        this.setState({
            tenantOptions,
            tenant: selectedTenant ? [selectedTenant] : []
        });
    }

    componentDidMount() {
        let propertyId = "";
        let tenant = [];
        let tenantOptions = [];
        if (this.props.tenantId) {
            let tenantDetails = this.getTenantOption(this.props.tenants[this.props.tenantId]);
            tenant = [tenantDetails];
            propertyId = this.props.tenants[this.props.tenantId].propertyId;
            this.setUnitOptions(propertyId)
            tenantOptions = tenant;
        }else if(Object.values(this.props.properties).length === 1){
            propertyId = Object.values(this.props.properties)[0].propertyId;
            this.setUnitOptions(propertyId);
            this.setTenantOptions(propertyId);
        }

        if(_.isEmpty(this.props.options)){
            this.props.showLoading(true);
            this.props.fetchOptions();
            this.props.showLoading(false);
        }

        this.setState({
            tenantOptions,
            tenant,
            properties: Object.values(this.props.properties),
            propertyId
        });
        // Mixpanel.track("Shift Tenant form: mounted");
    }


    getTenantOption(tenant) {
        if (tenant) {
            let label = "";
            if (tenant?.archived) {
                label += "[Archived] - ";
            }
            label += tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }

            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label
            };
        } else {
            return null;
        }

    }

    getUnitOption(unit) {
        if (unit) {
            return {
                id: unit.unitId,
                unitDetails: unit,
                label: unit.unitName + (unit.occupied? " - occupied" : "")
            }
        } else {
            return null;
        }
    }


    validateInput(name, value) {
        let val = String(value);
        let isValid = true;
        let errors = this.state.errors;
        let checks = [];
        switch (name) {
            case "unit":
                checks = [check_empty_field]
                break;
            case "tenant":
                checks = [check_empty_field];
                break;
            default:
                break;
        }
        for (let index in checks) {
            let previousError = errors[name];
            errors[name] = checks[index](val);
            if (errors[name].length > 0) {
                if (previousError.length == 0) {
                    this.setState((prevState) => ({ numErrors: prevState.numErrors + 1 }));
                }
                isValid = false;
                break;
            } else if (previousError.length > 0) {
                this.setState((prevState) => ({ numErrors: prevState.numErrors - 1 }));
            }
        }
        return isValid;
    }

    handleChange(event) {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({ [name]: val });
        this.validateInput(name, val);
    }

    async handleChangedOptions(name, selected) {
        await this.setState({ [name]: selected });
        this.validateInput(name, selected);
    }


    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["tenant", "unit"];
        let invalid_fields = fields.filter((field) => !(this.validateInput(field, this.state[field])));
        if (invalid_fields.length == 0) {
            await this.props.showLoading(true);
            // shift the tenant
            let action = await this.props.shiftTenant(this.state.tenant[0].id, this.state.unit[0].id)
            if (!action.errors) {
                this.setShiftTenantFormValues();
                this.setUnitOptions(this.state.propertyId);
            }
            await this.props.showLoading(false);
        }
        Mixpanel.track("Shift Tenant form: submit btn");
    }

    setShiftTenantFormValues(tenant = [], unit = []) {
        this.setState({
            tenant, unit
        });
    }

    handleCancelShifttenant(event) {
        event.preventDefault();
        this.setShiftTenantFormValues();
        Mixpanel.track("Shift Tenant form: cancel btn");
    }

    async handleSelectProperty(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId } = prevState;
            if (propertyId != value) {
                this.setTenantOptions(value);
                propertyId = value;
            }
            return {
                propertyId,
                tenant: []
            };
        });
        this.setUnitOptions(value);
    }


    render() {
        return (
            <Container>

                <Row className="mb-4 mt-1">
                    <Col lg={12}>
                        <p>Use this form to shift a {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} to an unoccupied unit.</p>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Form onSubmit={this.handleSubmit.bind(this)}>

                            <FormGroup row>
                                <CustomLabel
                                    sm={12} md={3}
                                    for="propertyId">
                                    Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                                </CustomLabel>

                                <Col sm={12} md={8} className="">
                                    <Row>
                                        <Col style={{ maxWidth: '450px' }} xs={12} sm={12}>
                                            <CustomInput
                                                type="select"
                                                id="propertyId"
                                                name="propertyId"
                                                className="mr-2"
                                                onChange={this.handleSelectProperty.bind(this)}
                                                value={this.state.propertyId}
                                            >
                                                <CustomPropertySelect propertiesArray={this.state.properties} />
                                            </CustomInput>
                                        </Col>

                                        <Col className="mt-2" style={{ maxWidth: '450px' }} xs={12} sm={12}>
                                            <Typeahead
                                                emptyLabel={this.state.propertyId === "" ? `Please first select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} property.` : `Choose ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}. No matches found.`}
                                                id="tenant"
                                                placeholder={`Select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} ...`}
                                                clearButton
                                                options={this.state.tenantOptions}
                                                name="tenant"
                                                selected={this.state.tenant}
                                                paginate={false}
                                                maxResults={10000000}  // chose a high number because we don't want to handle pagination. Just show all results.
                                                onChange={this.handleChangedOptions.bind(this, "tenant")}
                                                renderMenu={renderTenantSearchMenu}
                                            >
                                            </Typeahead>
                                            {this.state.errors.tenant.length > 0 && <p className="text-danger">{this.state.errors.tenant}</p>}
                                        </Col>
                                    </Row>
                                </Col>

                            </FormGroup>

                            {this.state.propertyId && (
                                <React.Fragment>
                                    <FormGroup row>
                                        <CustomLabel
                                            sm={12} md={3}
                                            for="unit">
                                            Select Unit
                                        </CustomLabel>
                                        <Col sm={12} md={8} className="">
                                            <Row>
                                                <Col className="mt-2" style={{ maxWidth: '450px' }} xs={12} sm={12}>
                                                    <Typeahead
                                                        emptyLabel={this.state.unit.length == 0 ? "Please first select property." : "Choose unit. No matches found."}
                                                        id="unit"
                                                        placeholder="Select Unit ..."
                                                        clearButton
                                                        options={this.state.unitOptions}
                                                        name="unit"
                                                        selected={this.state.unit}
                                                        onChange={this.handleChangedOptions.bind(this, "unit")}
                                                    >
                                                    </Typeahead>
                                                    {this.state.errors.unit.length > 0 && <p className="text-danger">{this.state.errors.unit}</p>}
                                                </Col>
                                            </Row>
                                        </Col>

                                    </FormGroup>

                                    <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                                        <IonButton type="submit" className="mx-2" style={{ width: "80%" }} disabled={this.state.numErrors > 0 || this.state.tenant.length < 1}>
                                            Shift {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                                        </IonButton>
                                        {this.state.tenant && (<IonButton type="submit"
                                            style={{ width: "80%" }}
                                            className="mx-2 mt-3"
                                            fill='outline'
                                            onClick={this.handleCancelShifttenant.bind(this)}
                                        >
                                            Cancel
                                        </IonButton>)}
                                    </Row>
                                </React.Fragment>)}
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShiftTenantForm);